import '../contests/components/contest_item';
import '../guides/components/edital_item';
import '../learning_guide/components/collapsible_guide_item';
import '../learning_guide/components/guide_list';
import './components/common_questions';
import './components/exams';
import './components/information';
import './components/menu_bar_float';
import './components/registrations';
import './components/seen_by';
import './components/side_banner';
import './components/summary';
import './index.scss';
import 'components/applied_exams';
import 'components/button_follow';
import 'components/create_account';
import 'components/directed_sheet_news';
import 'components/new_faq';
import 'components/preparation_guide';
import 'components/related_contests';
import 'components/related_contests_item';
import 'components/shadow_header';
import 'components/start_now';
import 'components/unlimited_access';
import 'styles/components/_list-group.scss';
import { MediaQuery } from 'utils/media_query';

(function ($) {
  'use strict';

  if (MediaQuery.is('xs')) {
    const $page = $('.q-contest-page');

    $('.q-tab-heading').on('click', $page, e => {
      const $heading = $(e.currentTarget);
      const tab = $heading.data('target-tab');

      $('.q-tab-content', $page).removeClass('active');
      $('.q-tab-heading', $page).removeClass('active');
      $(`.q-tab-content[data-tab="${tab}"]`, $page).addClass('active');

      $heading.addClass('active');
    });
  }
})(jQuery);
